import { CURRENT_NETWORK, getNetworkParams } from '../config/network';

// Switch network without triggering a page refresh.
// Returns true if switched (or already on it), false if user rejected.
export const switchNetwork = async (rawProvider) => {
  if (!rawProvider) throw new Error('No wallet provider');

  const targetHex = CURRENT_NETWORK.chainIdHex;

  try {
    await rawProvider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: targetHex }]
    });
    return true;
  } catch (switchError) {
    // 4902 = chain not added to wallet. Try adding it.
    // Some wallets (Trust) return -32603 for missing chain instead of 4902.
    const code = switchError?.code;
    const needsAdd = code === 4902 || code === -32603 || (switchError?.message || '').toLowerCase().includes('unrecognized');

    if (needsAdd) {
      try {
        await rawProvider.request({
          method: 'wallet_addEthereumChain',
          params: [getNetworkParams()]
        });
        // After adding, try switching again for wallets that don't auto-switch
        try {
          await rawProvider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: targetHex }]
          });
        } catch (_) { /* ignore */ }
        return true;
      } catch (addError) {
        if (addError?.code === 4001) return false; // user rejected
        throw addError;
      }
    }

    if (code === 4001) return false; // user rejected switch
    throw switchError;
  }
};

// Read current chainId from the raw provider as a decimal number
export const getCurrentChainId = async (rawProvider) => {
  if (!rawProvider) return null;
  try {
    const hex = await rawProvider.request({ method: 'eth_chainId' });
    return parseInt(hex, 16);
  } catch {
    return null;
  }
};

export const isOnCorrectNetwork = (chainId) => {
  return Number(chainId) === CURRENT_NETWORK.chainId;
};
